'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteMessageRelationPicker', ['$rootScope', 'Session', function ($rootScope, Session) {
      return {
        templateUrl: 'views/directives/notes/saNoteMessageRelationPicker.html',
        restrict: 'A',
        scope: {
          me: '=',
          org: '='
        },
        require: '^saNoteCreate',
        // controllerAs: 'NoteCtrl',
        link: function(scope, elem, attrs, NoteCtrl) {
          scope.state = {
            startDatepickerOpen: false,
            startDatepickerDate: moment().toDate(),
            endDatepickerOpen: false,
            endDatepickerDate: moment().toDate(),
            q: {

            }
          };

          NoteCtrl.relation = {
            start_date: scope.state.startDatepickerDate,
            end_date: scope.state.endDatepickerDate
          };

          scope.datePickerOptions = {
            'starting-day': scope.startOfWeekDay,
            'show-weeks': false
          };

          scope.openDatepicker = function(which, $event) {
            $event.preventDefault();
            $event.stopPropagation();

            if (which == 'start') {
              if (scope.state.startDatepickerOpen === true) {
                scope.state.startDatepickerOpen = false;
              } else {
                scope.state.startDatepickerOpen = true;
              }
            } else if (which == 'end') {
              if (scope.state.endDatepickerOpen === true) {
                scope.state.endDatepickerOpen = false;
              } else {
                scope.state.endDatepickerOpen = true;
              }
            }
          };

          scope.$watch('state.startDatepickerDate', function(newVal, oldVal) {
            NoteCtrl.relation.start_date = newVal;
          });

          scope.$watch('state.endDatepickerDate', function(newVal, oldVal) {
            NoteCtrl.relation.end_date = newVal;
          });

        }
      };
    }]);
